<template>
<div class="text-center">
  <div class="oneui-float-loading" v-if="isLoading">
  
</div>
<div v-if="!isLoading">
<slot></slot>
</div>
</div>
</template>

<script>
export default {
  name:"so-loading",
  props: ["isLoading"]
};
</script>

<style scoped>
.oneui-float-loading {
    background: #409EFF;
    position: relative;
    -webkit-animation: oneui-float-loading 1s ease-in-out infinite;
    animation: oneui-float-loading 1s ease-in-out infinite;
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
    width: .25em;
    height: .5em;
    font-size: 48px;
    display: inline-block;
    margin: 20px 0px;
}
.oneui-float-loading:after,
.oneui-float-loading:before {
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    background: inherit;
    -webkit-animation: inherit;
    animation: inherit;
}
.oneui-float-loading:before {
    right: .5em;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}
.oneui-float-loading:after {
    left: .5em;
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
}
@-webkit-keyframes oneui-float-loading {
    0%, 100% {
        box-shadow: 0 0 0 #409EFF, 0 0 0 #409EFF;
    }
    50% {
        box-shadow: 0 -.25em 0 #409EFF, 0 .25em 0 #409EFF;
    }
}
@keyframes oneui-float-loading {
    0%, 100% {
        box-shadow: 0 0 0 #409EFF, 0 0 0 #409EFF;
    }
    50% {
        box-shadow: 0 -.25em 0 #409EFF, 0 .25em 0 #409EFF;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/components/so-loading.vue